import createIcon from '../../createIcon';

/**
 * @component @name MobileScreenShare
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuOTk0OSAxLjAxTDYuOTk0ODggMUM1Ljg5NDg4IDEgNS4wMDQ4OCAxLjkgNS4wMDQ4OCAzVjIxQzUuMDA0ODggMjIuMSA1Ljg5NDg4IDIzIDYuOTk0ODggMjNIMTYuOTk0OUMxOC4wOTQ5IDIzIDE4Ljk5NDkgMjIuMSAxOC45OTQ5IDIxVjNDMTguOTk0OSAxLjkgMTguMDk0OSAxLjAxIDE2Ljk5NDkgMS4wMVpNMTYuOTk0OSAxOUg2Ljk5NDg4VjVIMTYuOTk0OVYxOVpNMTIuNzk0OSAxMy4yMlYxNC45N0wxNS45OTQ5IDExLjk4TDEyLjc5NDkgOVYxMC43QzkuNjg0ODggMTEuMTMgOC40NDQ4OCAxMy4yNiA3Ljk5NDg4IDE1LjRDOS4xMDQ4OCAxMy45IDEwLjU3NDkgMTMuMjIgMTIuNzk0OSAxMy4yMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MobileScreenShare = createIcon('MobileScreenShare', [
  [
    'path',
    {
      d: 'M16.9949 1.01L6.99488 1C5.89488 1 5.00488 1.9 5.00488 3V21C5.00488 22.1 5.89488 23 6.99488 23H16.9949C18.0949 23 18.9949 22.1 18.9949 21V3C18.9949 1.9 18.0949 1.01 16.9949 1.01ZM16.9949 19H6.99488V5H16.9949V19ZM12.7949 13.22V14.97L15.9949 11.98L12.7949 9V10.7C9.68488 11.13 8.44488 13.26 7.99488 15.4C9.10488 13.9 10.5749 13.22 12.7949 13.22Z',
      key: '1vgfp8',
    },
  ],
]);

export default MobileScreenShare;
